/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDiscreteTextValueListDto
 */
export interface CreateDiscreteTextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteTextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDiscreteTextValueListDto
     */
    selectedValues?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscreteTextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscreteTextValueListDto
     */
    $type?: CreateDiscreteTextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateDiscreteTextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateDiscreteTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateDiscreteTextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateDiscreteTextValueListDtoTypeEnum = typeof CreateDiscreteTextValueListDtoTypeEnum[keyof typeof CreateDiscreteTextValueListDtoTypeEnum];



/**
 * Check if a given object implements the CreateDiscreteTextValueListDto interface.
 */
export function instanceOfCreateDiscreteTextValueListDto(value?: unknown): value is CreateDiscreteTextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateDiscreteTextValueListDtoTypeEnum)[0];
}

export function CreateDiscreteTextValueListDtoFromJSON(json: any): CreateDiscreteTextValueListDto {
    return CreateDiscreteTextValueListDtoFromJSONTyped(json, false);
}

export function CreateDiscreteTextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDiscreteTextValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'selectedValues': json['selectedValues'] == null ? undefined : json['selectedValues'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateDiscreteTextValueListDtoToJSON(value?: CreateDiscreteTextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'dataTypeId': value['dataTypeId'],
        'selectedValues': value['selectedValues'],
        'isEnabled': value['isEnabled'],
        '$type': value['$type'],
    });
}

